import { $document, ItemView, util } from '@glu/core';

import template from './singleRowSelectorCell.hbs';

export default ItemView.extend({
  template,

  ui: {
    rowSelector: '.column-row-selector'
  },

  events: {
    'change @ui.rowSelector': 'handleSelectRowChange'
  },

  handleSelectRowChange() {
    util.each(
      this.$el.closest('tbody').find('input[name="single-row-selector"]'),
      (el) => {
        const $el = $document.find(el);
        $el.closest('tr').toggleClass('selected', $el.is(':checked'));
      }
    );

    // Set gridRowSelected on the model for the actioned row
    this.model.gridRowSelected = true;

    // Broadcast the row select event.
    this.appBus.trigger('grid:selectRow', this);
  },

  templateHelpers() {
    return {
      id: this.model.cid,
      value: this.options.value
    };
  }
});
